import type { JsonObject } from '@inf-monkeys-tech/monkeys';

const PAGINATION_PROPERTIES: JsonObject = {
  hasMore: { type: "boolean" },
  nextCursor: {
    oneOf: [
      { type: "string", minLength: 1, maxLength: 2048 },
      { type: "null" },
    ],
  },
  loadingMore: { type: "boolean" },
  errorCode: { type: "string", minLength: 1, maxLength: 128 },
};

export const cursorPaginationSchema = (): JsonObject => ({
  oneOf: [
    {
      type: "object",
      additionalProperties: false,
      required: ["hasMore", "nextCursor", "loadingMore"],
      properties: {
        mode: { const: "append" },
        ...PAGINATION_PROPERTIES,
        pageSize: { type: "integer", minimum: 1, maximum: 1000 },
        returned: { type: "integer", minimum: 0 },
        total: { type: "integer", minimum: 0 },
        loadedCount: { type: "integer", minimum: 0 },
        loadedStart: { type: "integer", minimum: 0 },
        loadedEnd: { type: "integer", minimum: 0 },
      },
    },
    {
      type: "object",
      additionalProperties: false,
      required: [
        "mode",
        "currentPage",
        "totalPages",
        "hasPrevious",
        "hasNext",
        "loading",
        "pageSize",
        "returned",
        "total",
        "loadedCount",
        "loadedStart",
        "loadedEnd",
      ],
      properties: {
        mode: { const: "window" },
        currentPage: { type: "integer", minimum: 1 },
        totalPages: { type: "integer", minimum: 1 },
        hasPrevious: { type: "boolean" },
        hasNext: { type: "boolean" },
        loading: { type: "boolean" },
        errorCode: { type: "string", minLength: 1, maxLength: 128 },
        pageSize: { type: "integer", minimum: 1, maximum: 1000 },
        returned: { type: "integer", minimum: 0 },
        total: { type: "integer", minimum: 0 },
        loadedCount: { type: "integer", minimum: 0 },
        loadedStart: { type: "integer", minimum: 0 },
        loadedEnd: { type: "integer", minimum: 0 },
      },
    },
  ],
});

